import { login, logout, getUserInfo } from '@/api/user'
import { setToken, getToken } from '@/libs/util'

export default {
    state: {
        userName: '',
        userId: '',
        avatorImgPath: '',
        token: getToken(),
        access: '',
        hasGetInfo: false
    },
    mutations: {
        setAvator(state, avatorPath) {
            state.avatorImgPath = avatorPath
        },
        setUserId(state, id) {
            state.userId = id
        },
        setUserName(state, name) {
            state.userName = name
        },
        setAccess(state, access) {
            state.access = access
        },
        setToken(state, token) {
            state.token = token
            setToken(token)
        },
        setHasGetInfo(state, status) {
            state.hasGetInfo = status
        }
    },
    actions: {
        // 登录
        handleLogin({ commit }, { userName, password }) {
            userName = userName.trim()
            return new Promise((resolve, reject) => {
                login({
                    userName,
                    password
                }).then(res => {
                    const data = res.data
                    commit('setUserName', userName);
                    // console.log(res);
                    commit('setToken', data.token)
                    resolve(data)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        // 退出登录
        handleLogOut({ state, commit }) {
            return new Promise((resolve, reject) => {
                // logout(state.token).then(() => {
                //   commit('setToken', '')
                //   commit('setAccess', [])
                //   resolve()
                // }).catch(err => {
                //   reject(err)
                // })
                // 如果你的退出登录无需请求接口，则可以直接使用下面三行代码而无需使用logout调用接口
                commit('setToken', '')
                commit('setAccess', [])
                resolve()
            })
        },
        // 获取用户相关信息
        getUserInfo({ state, commit }) {
            return new Promise((resolve, reject) => {
                try {
                    getUserInfo().then(res => {

                        const data = res.data
                        if (data.code == 200) {
                            commit('setUserId', data.data.proxy_user_id)
                            commit('setAccess', data.data.access)
                            commit('setHasGetInfo', true)
                            resolve(data)
                        } else if (res.code == 14001) {
                            this.$Message.error(res.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        } else {
                            this.$Message.error(res.msg);
                        }
                        // commit('setAvator', data.avator)
                        // commit('setUserName', data.data.realname)

                    }).catch(err => {
                        console.log(err)
                        reject(err)
                    })
                } catch (error) {
                    reject(error)
                }
            })
        }
    }
}